<template>
    <FormModel
        :action="submit" :labelCol="{span:4}" :model="config.function"
        :rules="rules" :wrapperCol="{span: 20}" style="width: 560px;">
        <a-alert :show-icon="true" type="warning">
            <template slot="message">
                <div>* 根据使用场景情况合理设置页面功能，人脸和号码查找需付费开通</div>
                <div>* 开通人脸或号码查询，照片上传后会自动进入识别流程并消耗次数</div>
            </template>
        </a-alert>
        <a-form-model-item label="人脸查找" prop="face_find" style="margin: 15px 0 5px 0;">
            <a-radio-group v-model="config.function.face_find">
                <a-radio :value="true">开启</a-radio>
                <a-radio :value="false">关闭</a-radio>
            </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="号码查找" prop="bib_find">
            <a-radio-group v-model="config.function.bib_find">
                <a-radio :value="true">开启</a-radio>
                <a-radio :value="false">关闭</a-radio>
            </a-radio-group>
            <div style="color:#999;font-size:12px;">
              当前剩余可用 {{detect.total-detect.used}} 次，请根据情况及时 <router-link :to="{name: 'UCenter.Detect'}">购买次数包</router-link>
            </div>
        </a-form-model-item>
    </FormModel>
</template>

<script>
    import func from "../../../../utils/func";
    import cache from "../../../../utils/cache";
    import FormModel from "../../../../comps/FormModel";

    export default {
        name: "Function",
        props: {
            user: Object,
            album: Object
        },
        components: {FormModel},
        data() {
            return {
                config: {
                    function: {
                        bib_find: false,
                        face_find: false,
                    }
                },
                detect: {total: 0, used: 0},
                rules: {
                    bib_find: {required: true},
                    face_find: {required: true},
                }
            }
        },
        mounted() {
            this.detect = this.user.detect;
            this.config = func.copyObject(this.album.config);
        },
        methods: {
            submit() {
                return cache.v1.album.setConfig(this.album.id, this.config)
                    .then(() => this.album.config = this.config);
            }
        }
    }
</script>

<style scoped>

</style>

